import { Component, OnInit, Input } from '@angular/core';
import { Colegio } from 'src/app/interfaces/colegio';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ColegiosService } from 'src/app/services/colegios.service';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import firebase from 'firebase';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  @Input() nombres: string;
  @Input() apellidos: string;
  @Input() colegio: Colegio;
  @Input() genero: string;
  @Input() idColegio: string;

  background = '#23273B';
  avatar: any = 'assets/img/logo.png';
  banner: boolean = true;
  banner2: boolean = false;

  bannerDatos: any;
  logoBanner: any = '';
  tituloBanner: any = '';
  subtituloBanner: any = '';

  constructor(
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private colegioService: ColegiosService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (this.colegio.background) {
      this.background = this.colegio.background;
    }
    if (this.colegio.avatar) {
      this.avatar = this.colegio.avatar;
    }
    // this.bannerService.getBannerByColegio(this.idColegio).subscribe(banners=>{
    //   if(banners.length>0){
    //     var datoBanner:any = banners[0].payload.doc.data()
    //     this.bannerDatos = datoBanner
    //     this.logoBanner = datoBanner.imagen
    //     this.tituloBanner = datoBanner.titulo
    //     this.subtituloBanner = datoBanner.subtitulo
    //     this.banner=this.bannerDatos.activo;
    //   }
    //   else{
    //     this.banner=false
    //   }
    // })
  }

  redireccion() {
    const userId = firebase.auth().currentUser?.uid; // Asegurar que el UID existe

    if (!userId) {
      console.error('❌ Error: UID no encontrado.');
      return;
    }

    fetch(
      'https://us-central1-colegia-education-demo.cloudfunctions.net/app/generarToken',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid: userId }), // Enviar correctamente el UID
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log('✅ Custom Token:', data.token);
        if (data.token) {
          this.router.navigate([
            '/padres/appsint/phone-school-demo-colegia.web.app\\dashboard?token=' +
              data.token,
          ]);
          // window.open(
          //   `https://phone-school-demo-colegia.web.app/dashboard?token=${data.token}`,
          //   '_blank'
          // );
        } else {
          console.error('❌ Error: Custom Token vacío.');
        }
      })
      .catch((error) => {
        console.error('❌ Error obteniendo el Custom Token:', error);
      });
  }

  // abrirEnlace(){
  //   console.log("me voooy", this.idColegio)
  //   window.open(this.bannerDatos.url)
  // }

  // quitarBanner(){
  //   this.banner=!this.banner
  //   this.banner2=!this.banner2

  // }
}